"use client"

// src/models/SuspensiveError.ts
var SuspensiveError = class _SuspensiveError extends Error {
  static assert(condition, message) {
    if (!condition) {
      throw new _SuspensiveError(message);
    }
  }
};
var useErrorBoundary_this_hook_should_be_called_in_ErrorBoundary_props_children = "useErrorBoundary: this hook should be called in ErrorBoundary.props.children";
var useErrorBoundaryFallbackProps_this_hook_should_be_called_in_ErrorBoundary_props_fallback = "useErrorBoundaryFallbackProps: this hook should be called in ErrorBoundary.props.fallback";
var useErrorBoundaryGroup_this_hook_should_be_called_in_ErrorBoundary_props_children = "useErrorBoundaryGroup: this hook should be called in ErrorBoundary.props.children";
var Delay_ms_prop_should_be_greater_than_or_equal_to_0 = "Delay: ms prop should be greater than or equal to 0";
var Suspensive_config_defaultOptions_delay_ms_should_be_greater_than_0 = "Suspensive: config.defaultOptions.delay.ms should be greater than 0";

export {
  SuspensiveError,
  useErrorBoundary_this_hook_should_be_called_in_ErrorBoundary_props_children,
  useErrorBoundaryFallbackProps_this_hook_should_be_called_in_ErrorBoundary_props_fallback,
  useErrorBoundaryGroup_this_hook_should_be_called_in_ErrorBoundary_props_children,
  Delay_ms_prop_should_be_greater_than_or_equal_to_0,
  Suspensive_config_defaultOptions_delay_ms_should_be_greater_than_0
};
//# sourceMappingURL=chunk-SA7ZETSA.js.map